import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { AuthStatus, DomainCustomConfig, useAuth } from '../auth';
import { applyDefaultConfig } from '../util';

export const configContext = createContext<DomainCustomConfig>({});

export const ConfigProvider: FC<PropsWithChildren & { config: DomainCustomConfig }> = ({ config, children }) => {
  return <configContext.Provider value={applyDefaultConfig(config)}>{children}</configContext.Provider>;
};

export const useConfig = (): DomainCustomConfig => {
  const auth = useAuth();
  const config = useContext(configContext);

  return auth.state?.status === AuthStatus.AUTHENTICATED ? auth.state.protectedConfig : config;
};

export const useSwitchAwareConfig = (): DomainCustomConfig => {
  const config = useConfig();
  const auth = useAuth();

  const switchedConfig = auth.state?.status === AuthStatus.AUTHENTICATED ? auth.state.switchedConfig : undefined;
  return switchedConfig ?? config;
};
